import { render, staticRenderFns } from "./CarouselView.vue?vue&type=template&id=951360d8&scoped=true"
import script from "./CarouselView.vue?vue&type=script&lang=js"
export * from "./CarouselView.vue?vue&type=script&lang=js"
import style0 from "./CarouselView.vue?vue&type=style&index=0&id=951360d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951360d8",
  null
  
)

export default component.exports